import React, { useEffect, useState } from "react";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import { LoadPanel, TreeList } from "devextreme-react";
import { Column, FilterPanel, FilterRow, SearchPanel } from "devextreme-react/data-grid";
import { Export } from "devextreme-react/bar-gauge";
import { function_TODOS_Parametros_Listar, function_TODOS_Parametros_Modificar } from "neftis7_apicaller/src/funciones/TODOS_Parametros";
import { LVGridCarga } from "../../Componentes/Basicos/LVGridCarga";

export const Parametros = () => {
  const [reload, setReload] = useState(false)
  const [loading, setLoading] = useState(false)
  const [actualizarArbol, setActualizarArbol] = useState(true);
  const [nodoSeleccionado, setNodoSeleccionado] = useState(null);
  const [arbol, setArbol] = useState([]);

  const getData = async () => {
    try {
      setReload(true)

      const resultParametros = await function_TODOS_Parametros_Listar()
      setArbol(resultParametros.data)

      setReload(false)
    } catch (error) {
      alert(error);
    }
  }

  useEffect(() => {
    getData()
  }, []);

  return (
    <PaginaCarga
      Titulo="PARAMETROS"
    >
      <div className="LV-FlexContainer" style={{ gap: 30, marginTop: 20, marginBottom: 20 }}>
        {loading ? (
          <p>Cargando datos...</p>
        ) : (
          <>
            <div style={{ marginTop: 20, width: "90%" }}>
              <LVGridCarga
                dataSource={arbol}
                columnAutoWidth={true}
                itemsExpr="Hijos"
                width={1000}
                allowDeleting={false}
                onRowUpdated={async (e) => {
                  try {
                    setLoading(true);
                    await function_TODOS_Parametros_Modificar(e.data.Parametro, e.data.Valor)
                    alert("Se ha modificado el parametro.")
                  } catch (err) {
                    alert("Error al guardar el valor");
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                <SearchPanel visible={true} />
                <FilterPanel visible={true} />
                <FilterRow visible={true} />
                <Export enabled={true} allowExportSelectedData={true} />
                <LoadPanel enabled={true} />

                <Column caption="Parametro" dataField="Parametro" width="400" alignment="Left" dataType="string" />
                <Column dataField="Valor" caption="Valor" width="200" />
              </LVGridCarga>
            </div>
          </>
        )}
      </div>
    </PaginaCarga >
  );
};
